import { Buttons } from "@/ui/Buttons";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { ParallaxHexagon } from "@/ui/ParallaxHexagon";
import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import { Parallax } from "react-scroll-parallax";
import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import bg_3 from "./bg_3.webp";
import classes from "./styles.module.scss";
import Vector from "./Vector_2.svg";

export default function ({
  className = "py-6 py-md-8",
  tagline,
  title,
  description,
  image_1,
  image_2,
  image_2_hexagon = true,
  buttons,
  vector = false,
  reverse = false,
  EditableText,
  EditableHtml,
  EditableImage,
  theme = "light",
}) {
  return (
    <div
      className={cn(className, classes.ContentSideImages)}
      data-reverse={reverse}
      data-vector={vector}
      data-bs-theme={theme}
    >
      {vector && <img src={Vector} alt="" className={classes.vector} />}
      <ParallaxBackground anim="y2n:x0:z1" image={bg_1} className={classes.bg_1} />
      <ParallaxBackground anim="y1:x2:z0" image={bg_2} className={classes.bg_2} />
      <ParallaxBackground anim="y2:x0:z0" image={bg_3} floating={false} className={classes.bg_3} />
      <Container fluid="lg">
        <Row className={cn({ "flex-row-reverse": !reverse })}>
          <Col xs={12} md={6}>
            <div
              className={cn("px-4 pb-5 pb-md-0", {
                "ps-lg-0 pe-lg-6": reverse,
                "pe-lg-0 ps-lg-6": !reverse,
              })}
            >
              <Tagline as={EditableText} path="tagline" tag="strong" className="d-block mb-3">
                <span dangerouslySetInnerHTML={{ __html: tagline }} />
              </Tagline>
              <EditableText path="title" tag="h2" className="text-balance mb-4">
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </EditableText>
              <EditableHtml path="description">
                <div dangerouslySetInnerHTML={{ __html: description }} />
              </EditableHtml>
              <Buttons buttons={buttons} className="justify-content-md-start flex-row my-5" />
            </div>
          </Col>
          <Col xs={12} md={6} className="position-relative">
            <ParallaxHexagon translateY={[-20, 0]} className={classes.img_1}>
              <EditableImage path="image_1" src={image_1} size="496x425" alt="" />
            </ParallaxHexagon>
            {image_2_hexagon ? (
              <ParallaxHexagon translateY={[-20, -60]} className={classes.img_2}>
                <EditableImage path="image_2" src={image_2} size="268x232" alt="" />
              </ParallaxHexagon>
            ) : (
              <Parallax translateY={[-20, -60]} className={classes.img_2}>
                <EditableImage path="image_2" src={image_2} size="268x232" alt="" />
              </Parallax>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
